<template>
    <vueRecaptcha
        class="vue-recaptcha"
        :size="captcha_option.size"
        :siteKey="captcha_option.siteKey"
        :tabindex="0"
        @verify="recaptchaVerified"
        @expire="recaptchaExpired"
        @fail="recaptchaFailed"

        :ref="el => { vueRecaptcha = el }"
    ></vueRecaptcha>
</template>

<script>
import vueRecaptcha from 'vue3-recaptcha2';
import { ref } from '@vue/reactivity';

export default {
    components: {
        vueRecaptcha,
    },
    props: {
        modelValue: {
            type: [String],
            defaul: false
        },
        size: {
            type: String,
            defaul: 'normal'
        }
    },
    emits: ['verify', 'expire', 'fail', 'update:modelValue'],
    setup(props, {emit}) {
        const width = ref(window.screen.width);
        const captcha_option = ref({
            size: width.value < 500 ? 'compact' : (props.size ? props.size : 'normal'),
            siteKey: process.env.RECAPTCHA_SITE_KEY,
        });

        const showButton = ref(false);
        const vueRecaptcha = ref(null);
        const recaptchaToken = ref(props.modelValue);

        function recaptchaVerified(response) {
            showButton.value = true;
            recaptchaToken.value = response;

            emit('update:modelValue', response);
            emit('verify', response);
        };
        function recaptchaExpired() {
            showButton.value = false;
            recaptchaToken.value = false;

            vueRecaptcha.value.reset();

            emit('expire', false);
            emit('update:modelValue', false);
        };
        function recaptchaFailed() {
            showButton.value = false;
            recaptchaToken.value = false;

            emit('fail', false);
            emit('update:modelValue', false);
        }

        return {
            vueRecaptcha,

            recaptchaVerified,
            recaptchaExpired,
            recaptchaFailed,

            recaptchaToken,

            captcha_option
        }
    },
}
</script>

<style lang="scss">
.vue-recaptcha {
    & > * {
        margin: auto;
    }
}
</style>
